export default {
  init() {
    // JavaScript to be fired on all pages

    function youtube_parser(url){
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }

    $(document).on('click', '.wod-link', function( e ){
      e.preventDefault();

      var url = $(e.target).attr('href');
      var data = $(e.target).data('wod');
      var code = youtube_parser(url);
      console.log(data);


      

      var iframe_url = 'https://www.youtube.com/embed/' + code + '?autoplay=1';

      $('#wod-iframe').attr('src', iframe_url);
      $('#wodModalLabel').html(data.name);

      $('#wodModal').modal()
    })


    $('#wodModal').on('hidden.bs.modal', function () {
      $('#wod-iframe').attr('src', '');
    })

    


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js